import React from 'react';
import { IconProps } from '.';

const SvgCategoryKids = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 4.75a7.254 7.254 0 0 0-6.9 5.018l-.205.633-.653-.128a1.25 1.25 0 1 0-.154 2.474l.665-.046.123.655a7.253 7.253 0 0 0 14.248 0l.123-.655.665.046a1.25 1.25 0 1 0-.154-2.474l-.653.128-.205-.633A7.253 7.253 0 0 0 12 4.75ZM3.873 8.753a8.753 8.753 0 0 1 16.255 0 2.75 2.75 0 0 1 .34 5.457 8.753 8.753 0 0 1-16.936 0 2.75 2.75 0 0 1 .34-5.457Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M10.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 15.75c-2.32 0-3.31-1.692-3.67-2.415l1.34-.67c.306.61.916 1.585 2.33 1.585 1.414 0 2.024-.975 2.33-1.585l1.34.67c-.36.723-1.35 2.415-3.67 2.415Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCategoryKids;
